export function versionDate(v: { effective_date?: string | null; source_date?: string | null; source_year?: number | null }) {
  if (v.effective_date) return `Effective ${v.effective_date}`;
  if (v.source_date) return `Source certified ${v.source_date}`;
  if (v.source_year) return `Source Act ${v.source_year}`;
  return 'Commencement unverified';
}
